import { URLConstructor } from './URLBuilder'

export const getQueryParamsAsObject = (): Record<string, string> => {
    const queryString: string = window.location.search
    const urlParams: URLSearchParams = new URLSearchParams(queryString)
    const params: Record<string, string> = {}

    urlParams.forEach((value: string, key: string): void => {
        params[key] = value
    })

    return params
}

/**
 * Does query param exist?
 *
 * @param param - The query param to check for.
 * @returns - True if the query param exists.
 */
export const hasQueryParam = (param: string): boolean => {
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search)

    return urlParams.has(param)
}

/**
 * Get value of query param.
 *
 * @param param - The query param to check for.
 * @returns - The value of the query param.
 */
export const getQueryParam = (param: string): Nullable<string> => {
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search)

    return urlParams.get(param)
}

/**
 * Redirect to a given URL.
 *
 * @param url - The URL to redirect to.
 */
export const redirectToURL = (url: URLConstructor): void => {
    window.location.href = url.constructURL()
}

/**
 * Navigate the top-level window to a URL, including from inside a cross-origin iframe.
 *
 * When CCS is embedded in the CX Suite (the new UI's /legacy, admin and custom-report iframes) the
 * top window is a different origin. A cross-origin Location only exposes the href setter and
 * replace(); reading anything else, assign included, throws a SecurityError ("Failed to read a named
 * property 'assign' from 'Location'"). Setting href is allowed and behaves like assign (it adds a
 * history entry), so it is the one form that works both embedded and at the top level (CXUI-948).
 *
 * The host iframe is sandboxed with allow-top-navigation-by-user-activation, so when embedded this
 * must be called while the user's click is still the active gesture.
 *
 * @param url - The URL to navigate to.
 * @param targetWindow - The window to navigate; defaults to the top-level window.
 */
export const navigateTopWindow = (url: string, targetWindow: Nullable<Window> = window.top): void => {
    if (!targetWindow) return

    targetWindow.location.href = url
}
